'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _validate = require('validate.js');

var _pickBy = require('lodash/pickBy');

var _pickBy2 = _interopRequireDefault(_pickBy);

var _identity = require('lodash/identity');

var _identity2 = _interopRequireDefault(_identity);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var constraints = {
    username: {
        presence: { message: 'modalValidatorUsernameRequired' },
        format: {
            pattern: '[a-z0-9_]+',
            flags: 'i',
            message: 'modalValidatorUsernameFormat'
        },
        length: {
            minimum: 6,
            tooShort: 'modalValidatorUsernameTooShort',
            maximum: 15,
            tooLong: 'modalValidatorUsernameTooLong'
        }
    },
    password: {
        presence: { message: 'modalValidatorPasswordRequired' },
        format: {
            pattern: '[a-z0-9_-]+',
            flags: 'i',
            message: 'modalValidatorPasswordFormat'
        },
        length: {
            minimum: 6,
            tooShort: 'modalValidatorPasswordTooShort',
            maximum: 15,
            tooLong: 'modalValidatorPasswordTooLong'
        }
    }
};


var validate = function validate(values) {
    var valuesObject = (0, _pickBy2.default)(values.toJS(), _identity2.default);

    _validate.validate.formatters.custom = function (errors) {
        return errors.reduce(function (allErrors, error) {
            var res = allErrors;
            res[error.attribute] = {
                message: error.error,
                code: error.attribute + '.' + error.validator
            };
            return res;
        }, {});
    };

    return (0, _validate.validate)(valuesObject, constraints, { format: 'custom', fullMessages: false });
};

exports.default = validate;
//# sourceMappingURL=validate.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/login-component/dist/main/login-form/validate.js
// module id = 493
// module chunks = 0